import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IFocusCell } from "../../../components-ui/data-table/DataTable";
import { IMucThuKhacSinhVienGanThemRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienGanThemRequest";
import { IMucThuKhacSinhVienSaveRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveRequest";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { IMucThuKhacSinhVienUpdateSoTienRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienUpdateSoTienRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import {
  IMucThuImportBoundResponse,
  IMucThuImportResponse,
} from "../../../model/respone/chung-tu/IMucThuImportResponse";
import { IMucThuKhacSinhVien } from "../../../model/respone/chung-tu/IMucThuKhacSinhVien";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMucThuActionsObj = {
  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_LOAI_THU_CHI: 0,
  CHANGE_TRANG_THAI_HOC: [] as number[],
  CHANGE_DOI_TUONG: [] as number[],
  CHANGE_KY_DANG_KY_ID: 0,
  CHANGE_DOT_NHAP_HOC: 0,
  CHANGE_DOT_MUC_THU_KHAC: 0,
  CHANGE_SINHVIEN_SELECTED_IDS: [] as string[],

  CHANGE_STATUS: {} as eReducerStatusBase,

  LOAD_HOCSINH_START: {} as ISinhVienSelectByLopsRequest,
  LOAD_HOCSINH_SUCCESS: {} as IStuHoSoSinhVienViewModel[],
  LOAD_HOCSINH_ERRR: "",

  LOAD_MUCTHUKHAC_START: {} as IMucThuKhacSinhVienSelectByLopsRequest,
  LOAD_MUCTHUKHAC_SUCCESS: {} as IMucThuKhacSinhVien[],
  LOAD_MUCTHUKHAC_ERRR: "",

  SHOW_INPUT_MODAL: false,

  CREATE_MUCTHUKHAC_START: {} as IMucThuKhacSinhVienSaveRequest,
  CREATE_MUCTHUKHAC_SUCCESS: {} as IMucThuKhacSinhVien[],
  CREATE_MUCTHUKHAC_ERRR: "",

  CREATE_AND_DUYET_MUCTHUKHAC_START: {} as IMucThuKhacSinhVienSaveRequest,

  GAN_THEM_AND_DUYET_MUCTHUKHAC_START: {} as IMucThuKhacSinhVienGanThemRequest,
  SHOW_GAN_THEM_MODAL: false,

  DUYET_MUCTHUKHAC_START: {} as IProcessRequest<number[]>,
  DUYET_MUCTHUKHAC_SUCCESS: undefined,
  DUYET_MUCTHUKHAC_ERRR: "",

  HUYDUYET_MUCTHUKHAC_START: {} as IProcessRequest<number[]>,
  HUYDUYET_MUCTHUKHAC_SUCCESS: undefined,
  HUYDUYET_MUCTHUKHAC_ERRR: "",

  CLOSE_PROCESSING_MODAL: undefined,

  DELETE_MUCTHUKHAC_START: {} as IIdsRequest,
  DELETE_MUCTHUKHAC_SUCCESS: undefined,
  DELETE_MUCTHUKHAC_ERRR: "",

  // Hủy và gỡ khoản thu = bỏ duyệt (tính lại công nợ) + xóa mức thu (Deletes). Chain HuyDuyet → Deletes.
  HUY_VA_GO_MUCTHUKHAC_START: {} as IProcessRequest<number[]>,

  CHANGE_FOCUSED_CELL: {} as IFocusCell,

  UPDATE_MUCTHUKHAC_START: {} as IMucThuKhacSinhVienUpdateSoTienRequest,
  UPDATE_MUCTHUKHAC_SUCCESS: {} as IMucThuKhacSinhVien,
  UPDATE_MUCTHUKHAC_ERRR: "",
  CHANGE_MUC_THU_FILTER: "",

  SHOW_HIDE_IMPORT_MODAL: false,
  CHANGE_MUCTHU_IMPORT_SELECTEDS: [] as IMucThuImportResponse[],
  IMPORT_START: {} as FormData,
  IMPORT_SUCESS: {} as IMucThuImportBoundResponse,
  IMPORT_ERROR: "",

  SAVE_IMPORT_START: {} as { cache_id: string; process_id: string },
  SAVE_IMPORT_SUCESS: undefined,
  SAVE_IMPORT_ERROR: "",

  IMPORT_HUYDUYET_START: {} as FormData,
  IMPORT_HUYDUYET_SUCESS: {} as IMucThuImportBoundResponse,
  IMPORT_HUYDUYET_ERROR: "",

  SAVE_IMPORT_HUYDUYET_START: {} as { cache_id: string; process_id: string },
  SAVE_IMPORT_HUYDUYET_SUCESS: undefined,
  SAVE_IMPORT_HUYDUYET_ERROR: "",

  HIDE_IMPORT_RESULT_MODAL: undefined,
};

export const eMucThuActionIds = generateActionTypeIds(
  eMucThuActionsObj,
  "MUC_THU",
);
export type IMucThuActionTypes = IGenericActionType<
  typeof eMucThuActionsObj,
  "MUC_THU"
>;
